import { render } from "./AdultModal.vue?vue&type=template&id=10f56fd8"
import script from "./AdultModal.vue?vue&type=script&lang=js"
export * from "./AdultModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__